import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';

import { Loading } from 'common/components/layout';
import { useLocalization } from 'redux/localization/utils/hooks';

const FacebookLogin = React.lazy(() => import('./FacebookLogin'));
const GoogleLoginComponent = React.lazy(() => import('./GoogleLoginComponent'));

const SocialLogin = (props) => {
  const { onSuccess } = props;

  const settings = useSelector((state) => state.setting.data);
  const { t } = useLocalization();
  const { usesFacebookLogin } = settings.facebookLogin;
  const { usesGoogleLogin } = settings.googleLogin;

  if (!usesFacebookLogin && !usesGoogleLogin) {
    return null;
  }

  // We use suspense here so that we don't have to unncessarily load Google and Facebook packages
  return (
    <Suspense fallback={<Loading />}>
      <div className="c7-divider">
        <span>{t('general.common.or')}</span>
      </div>

      <div className="c7-account-login__alt-login">
        {usesFacebookLogin && <FacebookLogin onSuccess={onSuccess} />}
        {usesGoogleLogin && <GoogleLoginComponent onSuccess={onSuccess} />}
      </div>
    </Suspense>
  );
};

export default SocialLogin;
